"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LottoExtraProcessor = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _util = require("./util");
var _ethTypes = require("@blockwell/eth-types");
class LottoExtraProcessor {
  constructor() {
    (0, _defineProperty2.default)(this, "key", "lotto");
  }
  async process(parameters, submission) {
    let wins = [];
    for (let {
      event,
      step
    } of (0, _util.findEvents)(submission, /^(TokenWin|ItemDropped)$/)) {
      let address = (0, _ethTypes.ethResolveStringParameter)(event.params, "token");
      let token = await (0, _util.getTokenData)(parameters.contracts, step.network, address);
      let value = (0, _ethTypes.ethResolveStringParameter)(event.params, "value");
      let dropAmount = (0, _ethTypes.ethResolveStringParameter)(event.params, "dropAmount");
      wins.push({
        token: token,
        value: value || dropAmount
      });
    }
    for (let {
      event,
      step
    } of (0, _util.findEvents)(submission, "Play")) {
      let value = (0, _ethTypes.ethResolveStringParameter)(event.params, "win");
      let transfer = step.events.find(it => it.event === "Transfer" && (0, _ethTypes.ethResolveStringParameter)(it.params, "2") === value);
      if (transfer) {
        let address = transfer.address;
        let token = await (0, _util.getTokenData)(parameters.contracts, step.network, address);
        wins.push({
          token: token,
          value
        });
      }
    }
    return wins;
  }
}
exports.LottoExtraProcessor = LottoExtraProcessor;
//# sourceMappingURL=LottoExtra.js.map